require('./cycle');

$(document).ready(function() {
	var $tabElements = $('.tabs');
	// only keep tabElements with more than one tab
	$tabElements = $tabElements.filter(function(_index, tabElement) {
		return $(tabElement).find('.tabs__tab').length > 1;
	});

	$tabElements.each(function(_index, tabElement) {
		var $tabElement = $(tabElement);
		var $tabContainer = $tabElement.find('.tabs__container');

		var $pager = $tabElement.find('.tabs__navigation');
		var pagerClass = 'tabs__link';
		var pagerClassActive = 'tabs__link--active';

		$pager.on('click', '.tabs__link', function() {
			// close mobile navigation
			$tabElement.children('.tabs__mobile-navigation-state').prop('checked', false);
		});

		$tabContainer.cycle({
			slides: '.tabs__tab',
			slideClass: 'tabs__tab',
			slideLeftClass: 'tabs__tab--left',
			slideActiveClass: 'tabs__tab--active',
			pager: $pager,
			pagerClass: pagerClass,
			pagerActiveClass: pagerClassActive,
			swipe: true
		});
		$tabContainer.on('transitionend webkitTransitionEnd oTransitionEnd otransitionend', function(event) {
			$tabContainer.css('height', '');
		});

		if (navigator.appVersion.indexOf('Safari') === -1 || !navigator.appVersion.match(/Version\/[5-9]\./)) {
			// TODO: transition of height was buggy in Safari (Version/9.1 Safari/601.5.17)
			// it looks like
			$tabContainer.on('cycle-before', function(event, opts, outgoing, incoming, forward) {
				$tabContainer.height($tabContainer.outerHeight());
				var height = $(incoming).outerHeight();
				$tabContainer.height(height);
			});
		}
		$tabElement.removeClass('tabs--pre-init').addClass('tabs--inititalized');

		$tabContainer.on('cycle-after', function(event, options, $current, $next, forward) {
			var activeLabel = options.pager.find('.' + options.pagerActiveClass).text();
			$tabElement.find('.tabs__mobile-navigation-header').text(activeLabel);
		});
	});
});
